const ActionTypes = {
  NORMAL_WORKING: 99,
  ANNUAL_LEAVE: 1,
  SICK_LEAVE: 2,
  ALTERNATIVE_LEAVE: 3,
  BEREAVEMENT_LEAVE: 4,
  LONGSERVICE_LEAVE: 5,
  SPECIAL_SERVICE_LEAVE: 6,
  DOMESTIC_LEAVE: 7,
  OTHER_PAID_LEAVE: 8,
  UNPAID_LEAVE: 9,
  OVERTIME_LIEU_LEAVE: 10,
  STUDY_LEAVE: 11,
  BIRTHDAY_LEAVE: 12,
  PARENTAL_LEAVE: 13
};

export function customActionTypeColor(action) {
  if (action) {
    switch (action) {
      case ActionTypes.NORMAL_WORKING:
        return {
          className: 'boxGreen'
        };
      case ActionTypes.ANNUAL_LEAVE:
        return {
          className: 'boxTomato'
        };
      case ActionTypes.SICK_LEAVE:
        return {
          className: 'boxOrange'
        };
      case ActionTypes.ALTERNATIVE_LEAVE:
        return {
          className: 'boxDodgerBlue'
        };
      case ActionTypes.BEREAVEMENT_LEAVE:
        return {
          className: 'boxMediumSeaGreen'
        };
      case ActionTypes.OVERTIME_LIEU_LEAVE:
        return {
          className: 'boxGray'
        };
      case ActionTypes.OTHER_PAID_LEAVE:
        return {
          className: 'boxViolet'
        };
      case ActionTypes.PARENTAL_LEAVE:
        return {
          className: 'boxSlateBlue'
        };
      case ActionTypes.UNPAID_LEAVE:
        return {
          className: 'boxLightGray'
        };
      case ActionTypes.LONGSERVICE_LEAVE:
        return {
          className: 'boxLight-1'
        };
      case ActionTypes.SPECIAL_SERVICE_LEAVE:
        return {
          className: 'boxLight-2'
        };
      case ActionTypes.DOMESTIC_LEAVE:
        return {
          className: 'boxLight-3'
        };
      case ActionTypes.STUDY_LEAVE:
        return {
          className: 'boxLight-4'
        };
      case ActionTypes.BIRTHDAY_LEAVE:
        return {
          className: 'boxLight-5'
        };
      default:
        return {
          className: 'boxDodgerBlue'
        };
    }
  } else return {};
}
